import React from 'react';
import { useTheme } from '../../context/shared/ThemeContext'

interface ConsentFormProps {
  onConsent: () => void;
  featureName: string;
  featureDescription: string;
}

const ConsentForm: React.FC<ConsentFormProps> = ({ onConsent, featureName, featureDescription }) => {
  const { themeClasses } = useTheme();

  return (
    <div className={`p-6 rounded-lg text-center ${themeClasses.cardBg} ${themeClasses.border}`}>
      <h3 className={`text-xl font-semibold ${themeClasses.primaryText}`}>Enable {featureName}</h3>
      <p className={`mt-2 max-w-2xl mx-auto ${themeClasses.secondaryText}`}>
        {featureDescription}
      </p>
      <div className="mt-6">
        <button
          onClick={onConsent}
          className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          I Understand and Consent
        </button>
      </div>
      <p className="mt-4 text-xs text-gray-500">
        You can withdraw your consent at any time in the settings menu.
      </p>
    </div>
  );
};

export default ConsentForm; 